<template>
    <div>
        <h5 class="heading-1 mb-4 mt-4">
            <span>ITENS DA REQUISIÇÃO</span>
        </h5>
        <app-tabela
            idTabela="tblRequisicaoItens"
            :itens="requisicaoItens"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="valorUnitario" slot-scope="data">{{
                data.valorUnitario | currency
            }}</template>
            <template slot="subTotal" slot-scope="data">{{
                data.subTotal | currency
            }}</template>
            <template slot="desconto" slot-scope="data">{{
                data.desconto | currency
            }}</template>
            <template slot="valorTotal" slot-scope="data">{{
                data.valorTotal | currency
            }}</template>
        </app-tabela>
    </div>
</template>

<script>
export default {
    props: {
        requisicao: {
            type: Object,
            default: () => {}
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            erros: [],
            campos: [
                {
                    key: 'descricao',
                    label: 'Item do Contrato',
                    filterable: true
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor Unitário',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'subTotal',
                    label: 'SubTotal',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'desconto',
                    label: 'Desconto',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {},

    created() {},

    computed: {
        requisicaoItens() {
            return this.requisicao.itens
        }
    },

    watch: {},

    components: {}
}
</script>
